export const postLogicRuleFormPrefix = 'post-survey-logic-rule-';

const generatePostLogicRuleFormName = clientId =>
  `${postLogicRuleFormPrefix}${clientId}`;

export default generatePostLogicRuleFormName;
